// @flow
import { createAction } from 'redux-actions';
import { type Map } from 'immutable';

export const mountSecondOpinion = createAction(
  'MOUNT_SECOND_OPINION',
  (payload?: () => void) => payload
);
export const unmountSecondOpinion = createAction('UNMOUNT_SECOND_OPINION');

type RequestContentPayload = {
  token: string,
  observationsMap: Map<string, *>,
};
export const requestContent = createAction(
  'SECOND_OPINION_CONTENT_REQUEST',
  (payload: RequestContentPayload) => payload
);

type ReceiveContentPayload = {
  ugc_id: UgcId,
};

export const receiveContent = createAction(
  'SECOND_OPINION_CONTENT_RESPONSE',
  (payload: ReceiveContentPayload) => payload
);



// WEBPACK FOOTER //
// ./src/pages/moderation/second-opinion/secondOpinionActions.js